import Descargas from "../../Components/Descargas/Descargas";
import TopBar from "../../Layout/TopBar/TopBar";

const DownloadFiles = () => {


    return (
        <div style={{display:"flex", flexDirection:"column", height:"100vh", overflow:"auto"}}>
            <TopBar />
            <Descargas />
        </div>
    );
}
export default DownloadFiles;